<div class="wrap" (click)="handleClick()">
  <div class="service-item">
    <img [src]="iconUrl" [alt]="title"  loading="lazy" height="32px" width="32px" />

    <p>
      {{ title }}
    </p>
  </div>
</div>
